/* eslint-disable */
// Заменить на методы из @vkplay/analytics после рефакторинга

const TMR_ID_VKPLAY_EXTRA = '3252498';

export const sendExtraEvents = (options) => {
  const {
    action, label, category, url, goal, eventParams,
  } = options;

  // Проверка на наличие маркетинговых кук в ConsentManager
  const hasCmp = typeof window.__cmp === 'function';

  let consentExist = false;
  let marketingCookie = false;

  if (hasCmp) {
    const consentStatus = window.__cmp('consentStatus');

    if (consentStatus) {
      consentExist = consentStatus.consentExists && consentStatus.userChoiceExists;
    }

    const purposeConsents = window.__cmp('getPurposeConsents');
    if (purposeConsents) {
      marketingCookie = purposeConsents.c52;
    }
  }

  if (hasCmp && !(consentExist && marketingCookie)) {
    return;
  }

  // Яндекс.Метрика
  if (typeof window.ym === 'function') {
    try {
      window.ym('params', {
        vkplay_events: label ? {
          [action]: label,
        } : action,
      });
    } catch (err) {
      console.error('Ошибка при отправке в Яндекс.Метрику', err);
    }
  }

  // top.mail.ru
  const _tmr = window._tmr_vkp_gen || (window._tmr_vkp_gen = []);
  const TMR_ID = options.id ? options.id : TMR_ID_VKPLAY_EXTRA;

  const goalParams = {
    category,
    action: action === `${category}_click` ? 'click' : action,
    ...(typeof label !== 'undefined' && { label }),
    url: url || window.location.href,
    ...eventParams,
  };

  const tmrOptions = {
    id: TMR_ID,
    type: 'reachGoal',
    goal: goal || 'vkplay',
    params: goalParams,
  };

  _tmr.push({ ...tmrOptions });

  // Дебаг
  if (window.location.search.includes('extra_events_debug=1')) {
    console.log('🚀 extra event sent:', action, label, category);
  }
};
